import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* À propos */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">À propos</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Perinature, entreprise de paysagisme depuis {companyInfo.since}. 
              Nous créons et entretenons vos espaces verts avec passion et professionnalisme.
            </p>
            <p className="text-gray-600 text-sm">
              Fondée par <span className="font-semibold">{companyInfo.founder}</span>
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Nos services</h3>
            <ul className="space-y-2">
              <li>
                <Link data-testid="footer-conception-link" to="/conception" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                  Conception de jardins
                </Link>
              </li>
              <li>
                <Link data-testid="footer-creation-link" to="/creation" className="text-gray-600 hover:text-red-500 transition-colors text-sm">
                  Création d'espaces verts
                </Link>
              </li>
              <li>
                <Link data-testid="footer-entretien-link" to="/entretien" className="text-gray-600 hover:text-green-600 transition-colors text-sm">
                  Entretien de jardins
                </Link>
              </li>
              <li>
                <Link data-testid="footer-contact-link" to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  Nous contacter
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin size={18} className="text-green-600 mr-2 mt-1 flex-shrink-0" />
                <span data-testid="footer-address" className="text-gray-600 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center">
                <Phone size={18} className="text-green-600 mr-2 flex-shrink-0" />
                <a data-testid="footer-phone-link" href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="text-gray-600 text-sm hover:text-green-700 transition-colors">{companyInfo.phone}</a>
              </li>
              <li className="flex items-center">
                <Mail size={18} className="text-green-600 mr-2 flex-shrink-0" />
                <a data-testid="footer-email-link" href={`mailto:${companyInfo.email}`} className="text-gray-600 text-sm break-all hover:text-green-700 transition-colors">{companyInfo.email}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 mt-8 pt-6 text-center">
          <p className="text-gray-500 text-sm">
            Tout droit réservés. Photo appartenant à Perinature. Site fait de nos mains vertes
          </p>
          <p className="text-gray-400 text-xs mt-2">
            © {new Date().getFullYear()} Perinature - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;